import { __decorate } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './footer-back-to-top.scss.js';
import '../../../atoms/buttons/generic-button2.0/index.js';

const ARROW_UP_SVG = $ `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.0002 10.2568L4.44504 17.8119C4.08988 18.1671 3.63786 18.3446 3.08898 18.3446C2.54011 18.3446 2.08809 18.1671 1.73293 17.8119C1.37777 17.4567 1.2002 17.0047 1.2002 16.4559C1.2002 15.907 1.37777 15.455 1.73293 15.0998L10.6441 6.18859C10.8379 5.99487 11.0477 5.85765 11.2737 5.77693C11.4997 5.69621 11.7419 5.65585 12.0002 5.65585C12.2585 5.65585 12.5006 5.69621 12.7267 5.77693C12.9527 5.85765 13.1625 5.99487 13.3562 6.18859L22.2675 15.0998C22.6226 15.455 22.8002 15.907 22.8002 16.4559C22.8002 17.0047 22.6226 17.4567 22.2675 17.8119C21.9123 18.1671 21.4603 18.3446 20.9114 18.3446C20.3625 18.3446 19.9105 18.1671 19.5554 17.8119L12.0002 10.2568Z" fill="currentColor"/></svg>`;
class FooterBackToTop extends s {
    constructor() {
        super(...arguments);
        this.threshold = 300;
        this.goUpArialabel = null;
        this.goHomepageArialabel = null;
        this.visible = false;
        this.scrollToTop = () => {
            const reduce = window.matchMedia &&
                window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
            this.visible = false;
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.handleScroll = this.handleScroll.bind(this);
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        this.handleScroll();
    }
    disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
        super.disconnectedCallback();
    }
    handleScroll() {
        const y = window.scrollY || window.pageYOffset || 0;
        this.visible = y > this.threshold;
        this.requestUpdate();
    }
    render() {
        var _a;
        const trimmed = (_a = this.goUpArialabel) === null || _a === void 0 ? void 0 : _a.trim();
        const ariaList = trimmed ? { 'aria-label': trimmed } : {};
        return $ `<generic-button-updated class="back-to-top" .styleType="${'dark'}" .color="${'purple'}" .type="${'primary'}" .appearance="${'icon-circle'}" .customSvg="${ARROW_UP_SVG}" .ariaList="${ariaList}" .skipAriaFallback="${!trimmed}" ?hidden="${!this.visible}" @cvt-click="${this.scrollToTop}"></generic-button-updated>`;
    }
}
FooterBackToTop.styles = css_248z;
__decorate([
    e({ type: Number })
], FooterBackToTop.prototype, "threshold", void 0);
__decorate([
    e({ type: String })
], FooterBackToTop.prototype, "goUpArialabel", void 0);
__decorate([
    e({ type: String })
], FooterBackToTop.prototype, "goHomepageArialabel", void 0);
__decorate([
    t()
], FooterBackToTop.prototype, "visible", void 0);
customElements.define('footer-back-to-top', FooterBackToTop);

export { FooterBackToTop };
